import * as React from 'react'
import styled from 'styled-components'

import * as bp from '../constants/breakpoints'

import * as S from '../styles'

import { Modal, ModalProps } from './Modal'
import { Pastille } from './Pastille'

export type ModalWithPastilleProps = ModalProps & {
  children: React.ReactNode
  className?: string
  pastille: React.ReactNode
}

export function ModalWithPastilleComponent({
  children,
  className,
  pastille,
  ...modalProps
}: ModalWithPastilleProps): React.ReactElement<ModalWithPastilleProps> | null {
  return (
    <Modal {...modalProps} className={className}>
      {pastille}
      {children}
    </Modal>
  )
}

export const ModalWithPastille = styled(ModalWithPastilleComponent)<ModalWithPastilleProps>`
  ${S.modal.Body} {
    display: flex;
    flex-direction: column;
  }

  ${Pastille} {
    margin-top: -80px;
    align-self: center;
    display: none;

    img {
      margin-top: -10px;
    }
  }

  @media screen and ${bp.TABLET} {
    ${S.modal.Wrapper} {
      max-width: 450px;
      overflow: visible;
    }

    ${Pastille} {
      display: flex;
    }
  }
`
ModalWithPastille.displayName = 'ModalWithPastille'
